// This function checks if the bid is a bid that was created before the creation of the website
// This is because the old bids are in a different drive and the new ones are in another drive
// It just checks if the id has a letter in it, then returns false if it does (old bids do not have a letter)

export function isOldBid(bid_id: string) {
    return !/[a-zA-Z]/.test(bid_id)
}